<template>
  <div
    class="landing-container"
    :class="{'landing-container--small': small}"
  >
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'VLandingContainer',
  props: {
    small: {
      type: Boolean,
      require: false
    }
  }
}
</script>

<style lang="scss" scoped>
.landing-container {
  margin: 0 auto;
  max-width: 1142px;
  width: 95%;

  &--small {
    max-width: 950px;
  }
}
</style>
